import { DEFAULT_CURRENCY } from '@/utils/constants'

export default {
    data () {
        return {
            currency: null, // API : originalCurrency
            exchangeRate: 0,
            amountOriginalCurrency: 0
        }
    },
    methods: {
        onSelectedCurrency ($event) {
            this.currency = $event
            if ($event?.exchangeRate) {
                this.exchangeRate = $event.exchangeRate
                this.handleCurrencyChange()
            } else {
                this.exchangeRate = null
                this.transaction.amount = this.amountOriginalCurrency
            }
        },
        handleCurrencyChange () {
            if (this.currency?.code === this.DEFAULT_CURRENCY) {
                this.exchangeRate = null
            } else if (this.curency?.code !== this.DEFAULT_CURRENCY && this.exchangeRate) {
                this.transaction.amount = this.calculateConversionRate(this.amountOriginalCurrency, this.exchangeRate)

                this.$forceUpdate()
            } else {
                this.transaction.amount = this.amountOriginalCurrency
                this.$forceUpdate()
            }
        },
        calculateConversionRate (amount, exchangeRate) {
            return Math.round((amount / exchangeRate) + Number.EPSILON) * 100 / 100
        }
    },
    computed: {
        DEFAULT_CURRENCY () {
            return DEFAULT_CURRENCY
          },
          showMultiCurrency () {
            return this.officeFeatureList.includes('MULTI_CURRENCIES_FEATURE')
          },
          currencies () {
            return this.$store.getters['ConfigStore/currencies']
          }

    }
}
